import { jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
export const FieldLabel = memo(({ required, children, ...rest }) => (_jsxs("label", { ...rest, children: [children, required ? ' *' : null] })));
export default FieldLabel;
